import { render } from "./loader.vue?vue&type=template&id=471a9546&scoped=true&ts=true"
import script from "./loader.vue?vue&type=script&lang=ts"
export * from "./loader.vue?vue&type=script&lang=ts"

import "./loader.scss?vue&type=style&index=0&id=471a9546&lang=scss&scoped=true"

import exportComponent from "/var/www/apps/mydr/mydr-welcome/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-471a9546"]])

export default __exports__